import { ChainId, Percent, Token, WETH9 } from '@uniswap/sdk-core'
import JSBI from 'jsbi'

import { V3_ADDRESSES, V2_ROUTER_ADDRESS as HYPERSWAP_V2_ROUTER_ADDRESS, XHSPX_ADDRESS } from '@hyperswap/addresses'

//TODO DEPLOY
export const MULTICALL2_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: V3_ADDRESSES[ChainId.MAINNET].MULTICALL2_ADDRESS,
  [ChainId.HYPEREVM_TESTNET]: V3_ADDRESSES[ChainId.HYPEREVM_TESTNET].MULTICALL2_ADDRESS,
  [ChainId.HYPEREVM]: V3_ADDRESSES[ChainId.HYPEREVM].MULTICALL2_ADDRESS,
}

export const V2_ROUTER_ADDRESS = HYPERSWAP_V2_ROUTER_ADDRESS

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export { PRELOADED_PROPOSALS } from './proposals'

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

export const AMPL = new Token(ChainId.MAINNET, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 9, 'AMPL', 'Ampleforth')
export const DAI = new Token(ChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin')
export const USDT = new Token(ChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD')
export const WBTC = new Token(ChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC')
export const FEI = new Token(ChainId.MAINNET, '0x956F47F50A910163D8BF957Cf5846D573E7f87CA', 18, 'FEI', 'Fei USD')
export const TRIBE = new Token(ChainId.MAINNET, '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B', 18, 'TRIBE', 'Tribe')
export const FRAX = new Token(ChainId.MAINNET, '0x853d955aCEf822Db058eb8505911ED77F175b99e', 18, 'FRAX', 'Frax')
export const FXS = new Token(ChainId.MAINNET, '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0', 18, 'FXS', 'Frax Share')
export const renBTC = new Token(ChainId.MAINNET, '0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D', 8, 'renBTC', 'renBTC')

export const mBTC = new Token(ChainId.HYPEREVM_TESTNET, '0x453b63484b11bbF0b61fC7E854f8DAC7bdE7d458', 8, 'MBTC', 'mBTC')
export const USDC = new Token(ChainId.HYPEREVM_TESTNET, '0x24ac48bf01fd6CB1C3836D08b3EdC70a9C4380cA', 8, 'USDC', 'USDC')
export const USDXL = new Token(
  ChainId.HYPEREVM,
  '0xca79db4b49f608ef54a5cb813fbed3a6387bc645',
  18,
  'USDXL',
  'Usdxl Token'
)

export const feUSD = new Token(ChainId.HYPEREVM, '0x02c6a2fA58cC01A18B8D9E00eA48d65E4dF26c70', 18, 'feUSD', 'feUSD')

export const UBTC = new Token(ChainId.HYPEREVM, '0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463', 8, 'UBTC', 'Unit Bitcoin')
export const UETH = new Token(
  ChainId.HYPEREVM,
  '0xbe6727b535545c67d5caa73dea54865b92cf7907',
  18,
  'UETH',
  'Unit Ethereum'
)

// Block time here is slightly higher (~1s) than average in order to avoid ongoing proposals past the displayed time
export const AVERAGE_BLOCK_TIME_IN_SECS = 13
export const PROPOSAL_LENGTH_IN_BLOCKS = 40_320
export const PROPOSAL_LENGTH_IN_SECS = AVERAGE_BLOCK_TIME_IN_SECS * PROPOSAL_LENGTH_IN_BLOCKS

export const GOVERNANCE_ADDRESS = '0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F'

export const TIMELOCK_ADDRESS = '0x1a9C8182C09F50C8318d769245beA52c32BE35BC'

const UNI_ADDRESS = '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984'
export const UNI: { [chainId in ChainId]: Token } = {
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
  [ChainId.HYPEREVM_TESTNET]: new Token(ChainId.HYPEREVM_TESTNET, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
  [ChainId.HYPEREVM]: new Token(ChainId.HYPEREVM, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
}

export const COMMON_CONTRACT_NAMES: { [address: string]: string } = {
  [UNI_ADDRESS]: 'UNI',
  [GOVERNANCE_ADDRESS]: 'Governance',
  [TIMELOCK_ADDRESS]: 'Timelock',
}

export const MERKLE_DISTRIBUTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e',
}

// TODO DEPLOY
const WETH_ONLY: ChainTokenList = {
  [ChainId.MAINNET]: [WETH9[ChainId.MAINNET]],
  [ChainId.HYPEREVM_TESTNET]: [WETH9[ChainId.HYPEREVM_TESTNET]],
  [ChainId.HYPEREVM]: [WETH9[ChainId.HYPEREVM]],
}

// TODO Test with USDC on HyperEVM Mainnet
// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC],
}

export const ADDITIONAL_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {
    '0xA948E86885e12Fb09AfEF8C52142EBDbDf73cD18': [UNI[ChainId.MAINNET]],
    '0x561a4717537ff4AF5c687328c0f7E90a319705C0': [UNI[ChainId.MAINNET]],
    [FEI.address]: [TRIBE],
    [TRIBE.address]: [FEI],
    [FRAX.address]: [FXS],
    [FXS.address]: [FRAX],
    [WBTC.address]: [renBTC],
    [renBTC.address]: [WBTC],
  },
}

export const UNTRADABLE_TOKENS: Set<string> = new Set([XHSPX_ADDRESS])

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {
    [AMPL.address]: [DAI, WETH9[ChainId.MAINNET]],
  },
}

// used for display in the default list when adding liquidity
// TODO COMMON BASES
export const SUGGESTED_BASES: Partial<ChainTokenList> = {
  [ChainId.MAINNET]: [DAI, USDC, USDT, WBTC],
  [ChainId.HYPEREVM_TESTNET]: [WETH9[ChainId.HYPEREVM_TESTNET], mBTC, USDC, USDXL],
  [ChainId.HYPEREVM]: [WETH9[ChainId.HYPEREVM], UBTC, UETH],
}

// used to construct the list of all pairs we consider by default in the frontend
// TODO Test with USDC on HyperEVM Mainnet
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [
    [
      new Token(ChainId.MAINNET, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643', 8, 'cDAI', 'Compound Dai'),
      new Token(ChainId.MAINNET, '0x39AA39c021dfbaE8faC545936693aC917d5E7563', 8, 'cUSDC', 'Compound USD Coin'),
    ],
    [USDC, USDT],
    [DAI, USDT],
  ],
}

export enum WalletType {
  BITGET = 'BITGET',
  METAMASK = 'METAMASK',
  RABBY = 'RABBY',
  INJECTED = 'INJECTED',
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = new Percent(10, 10_000)
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// used for rewards deadlines
export const BIG_INT_SECONDS_IN_WEEK = JSBI.BigInt(60 * 60 * 24 * 7)

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis JSBI.BigInt
export const ONE_BIPS = new Percent(1, 10)
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(100, JSBI.toNumber(BIPS_BASE)) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(300, JSBI.toNumber(BIPS_BASE)) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(500, JSBI.toNumber(BIPS_BASE)) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(1000, JSBI.toNumber(BIPS_BASE)) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(1500, JSBI.toNumber(BIPS_BASE)) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(50, 10000)

export const ZERO_PERCENT = new Percent(0)
export const ONE_HUNDRED_PERCENT = new Percent(1)

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = []

export const ARGENT_WALLET_DETECTOR_MAINNET_ADDRESS = '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8'

export const V1_MIGRATOR_ADDRESS = '0x16D4F26C15f3658ec65B1126ff27DD3dF2a2996b'

export const MERKL_DISTRIBUTOR_ADDRESS = '0x3Ef3D8bA38EBe18DB133cEc108f4D14CE00Dd9Ae'
